import Head from "next/head";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useRouter } from "next/router";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import cookie from "js-cookie";
import config from "../../../config";
import { ImageList } from "../../../src/components/design-pages/imageList";

const tileData = [
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/300x450 SDH HUNKER FLORA HL, SDG HUNKER GREY LT, SDG HUNKER GREY DK, SDM HUNKER GREY FL.webp",
    title: "Grey Kitchen Design with chimney and cabinets",
    alt: "Grey Kitchen Design with chimney and cabinets",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/300x450 SHG LOTUS MULTI HL, SBG N SLATE GREY DK, SBG N SLATE GREY LT, SFM N SLATE GREY DK.webp",
    title: "Classic Grey Kitchen Design with designer backsplash tiles",
    alt: "Classic Grey Kitchen Design with designer backsplash tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/300x450 SHG TRIANGLE MOSAIC HL, SBG RIVER WOOD SLATE, SBG RIVER WOOD GREY, SFM RIVER WOOD SLATE.webp",
    title: "Luxurious Grey Kitchen Design with dining table set and a chimney",
    alt: "Luxurious Grey Kitchen Design with dining table set and a chimney",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/300x600 SDG BLOCOS GREY LT & SDG BLOCOS GRIS.webp",
    title: "Modern Grey Kitchen Design with grey and white wall tiles",
    alt: "Modern Grey Kitchen Design with grey and white wall tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/300x600 SDH PERSIAN WINE HL, SDG PERSIAN GREY DK, SDG PERSIAN GREY LT, SDM PERSIAN GREY DK FL.webp",
    title: "Stylish Grey Kitchen Design with white kitchen cabinets",
    alt: "Stylish Grey Kitchen Design with white kitchen cabinets",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/DR Decor Moroccan Art Black White_600x1200 mm.webp",
    title: "Grey Kitchen Design with moroccan white and black tiles",
    alt: "Grey Kitchen Design with moroccan white and black tiles",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/GFT SPH Geometric Grey HL__Kitchen Ambiance_Ceramic Sparkle Wall Tiles_300x450 MM.webp",
    title: "Elegant Grey Kitchen Design with chimney,sink and stove",
    alt: "Elegant Grey Kitchen Design with chimney,sink and stove",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/HHG Atlantic Diamond Art4 HL, HBG Atlantic Stone Grey DK & HBG Atlantic Stone Grey LT_300x450 mm.webp",
    title: "Grey Kitchen Design with grey and white tiles and white cabinets",
    alt: "Grey Kitchen Design with grey and white tiles and white cabinets",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/Kitchen - 300x600 - 300x300 SDH PERSIAN WINE HL, SDG PERSIAN GREY DK, SDG PERSIAN GREY LT, SDM PERSIAN GREY DK FL.webp",
    title: "Modern Grey Kitchen Design with persian grey slab, sink and window",
    alt: "Modern Grey Kitchen Design with persian grey slab, sink and window",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/NU Canto Ash 600x1200.webp",
    title:
      "Luxurious Grey Kitchen Design with large window and dining set,sink",
    alt: "Luxurious Grey Kitchen Design with large window and dining set,sink",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/SHG MOORISH ART GREY HL, SBG STONEMOOD GREY DK, SBG STONEMOOD GREY LT & SFM STONEMOOD GREY DK _300x450mm.webp",
    title:
      "Classic Grey Kitchen Design with dining table set and sink,plant pots",
    alt: "Classic Grey Kitchen Design with dining table set and sink,plant pots",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/SHG PEANUTS CUP PLATE HL, SBG 3D STRIPS GREY DK & SBG 3D STRIPS GREY LT _300x450mm.webp",
    title:
      "Grey Kitchen Design with 3D strips grey wall tiles,chinmey and sink",
    alt: "Grey Kitchen Design with 3D strips grey wall tiles,chinmey and sink",
  },
  {
    src: "https://orientbell.com/media/design-images/kitchen/Grey 13/SHM Multi 2by3 Geometric HL, SBM Grey LT Square 2by3, SBM Grey DK Square 2by3 & SFM Grey DK Square 2by2_300x450 mm.webp",
    title: "Stylish Grey Kitchen Design with grey and white titles and oven",
    alt: "Stylish Grey Kitchen Design with grey and white titles and oven",
  },
];

const text = `If your kitchen feels outdated or cramped, it’s time to revamp it with grey kitchen designs to restore its charm. A modern grey kitchen design effortlessly blends elegance and versatility, turning your vision into reality. From sleek grey modular kitchen layouts to various decor elements, grey transforms your kitchen into a clean and chic space that isn’t difficult to maintain. You can pair grey kitchen designs with warm wooden tones on the walls, complementary flooring and countertops to create a flawless look. Explore kitchen design ideas that bring together functional units, refined finishes, and smart layouts to create a space you’ll love to cook in.`;

const settings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
};
const faqs = [
  {
    question: "What colours go with grey in a kitchen?",
    answer:
      "Grey pairs well with various colours, such as white for a clean, modern look or wood tones for a natural, warm contrast. Bold colours like black and dark blue can also complement grey, adding depth and sophistication to your kitchen design.",
  },
  {
    question: "Is grey a good colour for a kitchen?",
    answer:
      "Yes, grey is an excellent colour for a kitchen. It offers versatility, blending well with different finishes, and can create a calm, modern atmosphere. Grey is easy to maintain and works well in both large and small kitchens, making it a timeless choice.",
  },
  {
    question: "What colour tiles go with a grey kitchen?",
    answer:
      "White, black, or even marble-patterned tiles pair beautifully with a grey kitchen. For a more open look, consider tiles with a glossy finish on the walls. You can install wooden tiles in a dark brown shade on the floor or play with mosaic tiles in multi-colour to add contrast. These options will enhance the overall aesthetic of your space.",
  },
  {
    question: "What colour splashback with the grey kitchen?",
    answer:
      "For a grey kitchen, a white or black splashback creates a striking contrast. Alternatively, you can opt for geometric or patterned tiles for a sleek, modern feel. You can also play around with vibrant colours like yellow to add a pop of personality to your kitchen.",
  },
];
function GreyKitchen() {
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=kitchen-designs`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);
  return (
    <>
      <Head>
        <title>Grey Kitchen Design Ideas for a Modern Touch | Orientbell</title>

        <meta
          name="title"
          content="Grey Kitchen Design Ideas for a Modern Touch | Orientbell"
        />
        <meta
          name="description"
          content="Explore Grey Kitchen Design ideas at Orientbell. Discover sleek and sophisticated grey kitchen layouts that add elegance and style to your home. Get inspired and start designing today!
"
        />
      </Head>
      <div className="designpage-section">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/kitchen-designs">
              Kitchen Designs
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/kitchen-designs/grey-kitchen">
              Grey Kitchen
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="designpage-heading-bx padding-spacing">
            <h4>Showing {tileData.length} results for </h4>
            <h1>Grey Kitchen Design</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div className="obl-master-design-section">
            <h2>Grey Kitchen Gallery</h2>
            <div className="designpage-category-row inner-design-gallery">
              <ImageList tileData={tileData} />
            </div>

            <div className="bottom-content">
              <div className="common-text-content-section">
                <h2>Small Grey Kitchen Design</h2>
                <p>
                  A <strong>grey kitchen </strong>design can create a stylish
                  and functional space even in the smallest kitchens. With the
                  right layout, lighting, and storage, a small kitchen can be
                  maximized while remaining sleek and modern.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong>Optimised Layout and Countertops </strong>
                    </h5>
                    <p>
                      The layout is key to maximising space in a small grey
                      kitchen design. Focus on the work triangle (sink, stove,
                      and fridge) to ensure an efficient workflow. Compact
                      designs for countertops will maximise the available space
                      without appearing crowded. L-shape or U-shape layouts
                      could be considered, as they are great fits for smaller
                      kitchens. They allow smooth movement while keeping
                      countertops functional.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Lighting to Enhance Space </strong>
                    </h5>
                    <p>
                      Lighting is essential in compact kitchens to make the
                      space feel larger. Bigger windows or a glass door could
                      help make the kitchen seem less cramped. Artificial
                      lighting, such as under-cabinet lights, pendant lights,
                      and recessed ceiling lights, could further brighten up the
                      kitchen.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Smart Storage Solutions </strong>
                    </h5>
                    <p>
                      Efficient storage is essential in a{" "}
                      <a href="https://www.orientbell.com/design-ideas/kitchen-designs/small-kitchen">
                        small kitchen
                      </a>
                      . To keep your kitchen organised, use shelves, tall
                      cabinets, and pull-out drawers. Get modular units that can
                      be customised to fit your layout. They will help you meet
                      your storage needs while maintaining a clutter-free space.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Coordinated Colour Scheme </strong>
                    </h5>
                    <p>
                      The right colour scheme can make a huge difference in a
                      small grey kitchen design. Grey would be an appropriate
                      base colour as it will work well with other lighter tones
                      used for walls and countertops. Adding white walls or
                      countertops would give a small grey kitchen the feel of
                      open space. You can also add accents of darker grey or
                      natural textures to enhance the design.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Large Tiles for a Spacious Feel</strong>
                    </h5>
                    Incorporate large tiles for flooring to minimise grout
                    lines. Use a subtle grey or marble finish to complement the
                    rest of your design, making the kitchen look larger and more
                    luxurious.
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2> Grey Modular Kitchen Colour Combination</h2>
                <p>
                  A grey modular kitchen opens out to a world of possibilities
                  for striking kitchen designs. By blending grey with
                  complementary shades, you can craft a space that’s both
                  stylish and functional. For inspiration, explore these
                  timeless, trendy colour combinations:
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Grey and White Kitchen Designs </strong>
                    </h5>
                    <p>
                      Grey and white have a classic feel that offers elegance
                      and simplicity. White brightens the grey and adds a sense
                      of openness to the kitchen, making it more welcoming. Use
                      white cabinets or countertops with grey walls or flooring
                      for a clean, balanced look.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Black and Grey Kitchen Designs</strong>
                    </h5>

                    <p>
                      For a bold vibe, opt for a black-and-grey kitchen design.
                      Black accents, such as appliances or cabinets, paired with
                      lighter grey tones on the walls create a striking contrast
                      that’s perfect for modern kitchens.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Monochrome Grey Kitchen</strong>
                    </h5>
                    <p>
                      A monochrome grey kitchen design uses varying shades of
                      grey to create depth and harmony. Combine light grey walls
                      with darker grey accent walls or countertops to achieve a
                      seamless, contemporary look.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Grey and Blue Kitchen</strong>
                    </h5>
                    <p>
                      Pair grey with blue for a refreshing and modern touch.
                      This combination softens the overall look of the kitchen,
                      creating a calming yet chic atmosphere. Use blue for
                      cabinets or walls, while grey adds depth through
                      countertops or flooring.
                    </p>
                  </li>

                  <li>
                    <h5>
                      <strong>Grey and Yellow Kitchen </strong>
                    </h5>
                    <p>
                      For a vibrant and cheerful look, pair grey with yellow.
                      Yellow brings energy and brightness to the neutral grey
                      base, making your kitchen feel lively. Incorporate yellow
                      through backsplash tiles, decor, or lighting fixtures for
                      a stylish contrast.
                    </p>
                    <p>
                      These grey kitchen colour combinations offer a variety of
                      looks to transform your space into a modern masterpiece.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Why Choose a Grey Kitchen?</h2>
                <p>
                  A grey kitchen perfectly combines style and practicality. Its
                  neutral tone allows for endless customisation to suit your
                  taste.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Adaptable with Different Finishes </strong>
                    </h5>
                    <p>
                      Grey works perfectly with all kinds of finishes, from
                      matte to glossy to textured surfaces. It gives the overall
                      look of your{" "}
                      <a href="https://www.orientbell.com/design-ideas/kitchen-designs">
                        {" "}
                        kitchen design{" "}
                      </a>
                      an upgrade. Whether you want a sleek modern look or a warm
                      rustic charm, grey adapts beautifully to create a cohesive
                      and stylish space.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong> Versatility in Colour Schemes</strong>
                    </h5>
                    <p>
                      Grey pairs beautifully with various colour schemes,
                      allowing you to create a kitchen that’s modern, rustic, or
                      classic. It acts as the perfect base to complement other
                      hues and accents seamlessly.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Pair Up With Other Materials</strong>
                    </h5>
                    <p>
                      Grey kitchen designs are incredibly versatile, allowing
                      you to pair them with bold accents, natural wood tones, or
                      metallic finishes. It will help you to create a customised
                      look that suits your taste.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Timeless Appeal </strong>
                    </h5>
                    <p>
                      Grey kitchen designs never go out of style. Their
                      adaptable nature ensures they remain trendy while blending
                      well with any decor changes over the years.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>Tips For Maintaining A Grey Kitchen</h2>
                <p>
                  A grey modular kitchen exudes style and sophistication, but
                  maintaining its charm requires consistent care. Here are some
                  tips to keep your kitchen looking fresh and inviting:
                </p>
                <ul>
                  <li>
                    <p>
                      Regular wipe-downs are essential to maintain the clean and
                      sleek appearance of grey surfaces. Use a soft cloth and
                      gentle cleaning solutions to prevent stains or scratches.
                    </p>
                  </li>
                  <li>
                    <p>
                      Maximise your space by keeping countertops clutter-free.
                      Use under-counter storage to maintain an organised and
                      polished look.
                    </p>
                  </li>
                  <li>
                    <p>
                      Give importance to cleaning the high-touch areas of your
                      kitchen space. They include cabinet handles, appliances,
                      utensils and backsplash tiles. It takes care of hygiene
                      and maintains your decor style.
                    </p>{" "}
                  </li>

                  <li>
                    <p>
                      Deep clean periodically to remove grime and maintain the
                      durability of your grey modular kitchen. Focus on corners
                      and hidden spots for a spotless finish.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="common-text-content-section">
                <h2>How Do I Decorate My Grey Kitchen?</h2>
                <p>
                  Decorating your grey kitchen is an exciting way to add
                  personality and style to the space. With the right combination
                  of decor, fixtures, and finishes, you can transform your
                  kitchen into a functional yet beautiful area.
                </p>
                <ul>
                  <li>
                    <h5>
                      <strong> Incorporate Artwork </strong>
                    </h5>
                    <p>
                      Add artwork or framed prints to create a focal point.
                      Choose pieces that complement the grey tones and enhance
                      the overall look of the space. Abstract or nature-inspired
                      art can add a touch of warmth and vibrancy.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Mix Finishes for Depth</strong>
                    </h5>
                    <p>
                      Experiment with different finishes such as matte, glossy,
                      or textured surfaces. Mixing finishes can add depth and
                      character to your kitchen design, giving the space a
                      dynamic, layered look.
                    </p>
                  </li>
                  <li>
                    <h5>
                      <strong>Choose Complementary Fixtures</strong>
                    </h5>
                    <p>
                      Select fixtures like faucets, handles, and light fittings
                      in contrasting colours. You can go for gold, black, or
                      chrome to create an interesting contrast with the grey
                      base. These small accents can elevate the overall design.
                    </p>{" "}
                  </li>

                  <li>
                    <h5>
                      <strong>Stylish Tiles Design </strong>
                    </h5>
                    <p>
                      Opt for a unique tile design for your backsplash or
                      flooring. Subway tiles, mosaic patterns, or marble
                      finishes in shades of grey or complementary tones can
                      enhance the style of your kitchen.
                    </p>
                  </li>

                  <li>
                    <h5>
                      {" "}
                      <strong>Personalise with Decor Items</strong>
                    </h5>
                    <p>
                      Add functional yet stylish decor pieces like plants, open
                      shelving, or decorative bowls. These items bring life to
                      the space and allow you to express your style while
                      maintaining a cohesive look.
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="designpage-faq-section padding-spacing">
              <h2>FAQs About Grey Kitchen Design</h2>
              <div className="newacd designpage-faq-row">
                <ul className="accordion">
                  {displayedFAQs.map((faq, index) => (
                    <li key={index}>
                      <a className="toggle" onClick={() => handleToggle(index)}>
                        {index + 1}. {faq.question}
                      </a>
                      {activeIndex === index && (
                        <ul className="inner">
                          <li>{faq.answer}</li>
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
                {faqs.length > 5 && (
                  <div className="tru_btn_new design-page">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? "Show Less" : "Read More"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {relatedBlogData?.length > 0 && (
              <div className="tile-related-blog">
                <h2 className="title">Related Blogs</h2>
                <div className="designpage-relatedpost-row">
                  <Slider {...settings}>
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="related-blog-col" key={index}>
                          <div className="blog-figure">
                            <a href={obj.permalink}>
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="blog-text">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                            <div className="listingText">
                              <p>
                                {" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.content.slice(0, -11),
                                  }}
                                />
                              </p>
                              <div className="listingButton">
                                <a href={obj.permalink}>Read More</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default GreyKitchen;
